import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '@/api/api';
import { ENDPOINT } from '@/constants/endpoints';
import { DirectReportsResponse } from '@/types/account-settings';

export const accountSettingsApi = createApi({
  reducerPath: 'accountSettingsApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['AccountSettings'],
  endpoints: builder => ({
    getDirectReports: builder.query<DirectReportsResponse, void>({
      query: () => ({
        url: ENDPOINT.ACCOUNT_SETTINGS.GET_DIRECT_REPORTS(),
        method: 'GET',
      }),
      providesTags: ['AccountSettings'],
    }),
  }),
});

export const { useGetDirectReportsQuery } = accountSettingsApi;
